module.exports = __webpack_public_path__ + "static/media/rem-galleu-win.45280df5.png";